(function ($) {
    //dom ready
    $(function () {
        $('#review-link').click(function () {
            if (evo.$.window.width() < evo.mq.screenSmMin) {
                var $reviewHeader = $('#pdp-reviews').find('.js-mobile-accordion-header');
                if (!$reviewHeader.hasClass('active')) {
                    $reviewHeader.trigger('click');
                }
            }
        });

        //init the hero.js plugin on the hero container
        $('.js-pdp-hero-container').heroInteraction();

        var anchorNavOffset = $('.mashup-anchor-nav').length ? 80 : 75;

        $('.js-scrolltoid').scrollToID({
            offset: anchorNavOffset
        });

        $('.mobile-accordion-group').mobileAccordion();
        $('.desktop-accordion-group').mobileAccordion({ desktopAccordion: true });

        // call bootstrap scrollspy for sticky pdp-navigation.  offset equals height of pdp-anchor-nav + pdp description header
        evo.$.body.scrollspy({
            target: '#pdp-anchor-navigation', offset: 84
        });
        $('#related-products-row').hoverScroll({
            parent: $('#related-products-container')
        });

        var registerPageViewUrl = $('#page-view-url').val();
        if (registerPageViewUrl) {
            $.post(registerPageViewUrl);
        }
    });
})(jQuery);